/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { forEach, defer, isElement } from 'lodash';

import { publish, subscribe } from '../2-utilities/event';
import { queryAncestor } from '../2-utilities/dom';

import {
    MARKERS_CHANGED as markersChanged,
    QUIT_AUTOPLAY as quitAutoplay
} from '../3-data/consts/eventNames';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const moduleName = 'filter',
    baseSelector = `.js-${moduleName}`,
    clearSelector = `${baseSelector}-clear`,
    filterButtonSelector = `${baseSelector}-button`,
    filterDialogSelector = `${baseSelector}-dialog`,
    filterDialogOkButtonSelector = `${baseSelector}-dialog-ok`,
    hideClassName = '--hide';

let filters = {
    'type': 'all',
    'score': 'all',
    'position': 'all'
};

/* ========================================================================== *\
    Functionality
/* ========================================================================== */
function toggleMarker(marker) {
    marker.classList.remove(hideClassName);

    const type = marker.getAttribute('data-type'),
        score = marker.getAttribute('data-score'),
        position = marker.getAttribute('data-position');

    if (
        (type !== filters.type && filters.type !== 'all') ||
        (score !== filters.score && filters.score !== 'all') ||
        (position !== filters.position && filters.position !== 'all')
    ) {
        marker.classList.add(hideClassName);
    }
}

function changeMarkers({ detail }) {
    const { selector } = detail,
        marker = document.querySelector(selector);

    if (!isElement(marker)) {
        defer(changeMarkers);
    }

    toggleMarker(marker);
}

function onChange() {
    const value = this.value,
        name = this.name,
        markers = document.querySelectorAll('.js-marker');

    filters[name] = value;

    forEach(markers, toggleMarker);

    publish(quitAutoplay);
}

function onCheckChange(el, items) {
    const name = el.name,
        value = el.value,
        markers = document.querySelectorAll('.js-marker');

    if (filters[name] !== value) {
        filters[name] = value;
    } else {
        filters[name] = 'all';
    }

    forEach(items, item => {
        if (item.value === value) {
            return;
        }

        item.checked = false;
    });

    forEach(markers, toggleMarker);

    publish(quitAutoplay);
}

function setup(element) {
    const items = element.querySelectorAll('.js-filter-checkbox');

    if (items.length) {
        forEach(items, item => {
            item.addEventListener('change', () => onCheckChange(item, items));
        });
    } else {
        element.addEventListener('change', onChange);
    }
}

function resetFilters(event) {
    event.preventDefault();

    const elements = document.querySelectorAll(baseSelector);

    forEach(elements, element => {
        const items = element.querySelectorAll('.js-filter-checkbox');

        if (items.length) {
            forEach(items, item => {
                item.checked = false;
            });

            forEach(Object.keys(filters), (key) => {
                filters[key] = 'all';
            });

            return;
        }

        const name = element.name,
            value = 'all';

        element.value = value;

        filters[name] = value;
    });

    const markers = document.querySelectorAll('.js-marker');

    forEach(markers, toggleMarker);
}

function init(baseElements = document.querySelectorAll(baseSelector)) {
    forEach(baseElements, setup);

    const clearElements = document.querySelectorAll(clearSelector);
    forEach(clearElements, clearElement => {
        clearElement.addEventListener('click', resetFilters);
    })
}

init();
subscribe(markersChanged, changeMarkers);